let $el;

/**
 * @param {string} message
 */
export default function announce(message) {
  if (!$el) {
    $el = document.createElement('div');
    $el.setAttribute('aria-live', 'assertive');
    $el.setAttribute('aria-atomic', 'true');
    $el.classList.add('sr-only');

    document.body.appendChild($el);
  }

  $el.innerHTML = message;
}
